<template>
  <div class="w-full px-2 flex flex-col">

    <!--
    <div class="mt-2 timeline-options">
      <div class="timeline-option" v-for='[tid,color] in transformSelectionOptions' :key='tid'>
        <slot name='tid'
              :tid='tid'
              :color='color'
              :select='select'
              :selected='selectedTransformTid === tid'
              />
        <slot v-if='selectedTransformTid !== tid'
              name='selectedtid'
              :tid='tid'
              :color='color'
              :select='select'
              :selected='selectedTransformTid === tid'
              />
      </div>
    </div>
    -->
    <div v-if='!isCondensed' class="flex-none text-center flex flex-row justify-center text-white">
      <div class="w-8 text-lg text-white">{{this.currentTime.toFixed(0)}}s</div>
      /&nbsp;
      <a @click='chooseTimelimit = true' class="ml-1 underline text-lg text-white font-semibold">{{timeline.duration.toFixed(1)}}s</a>


    </div>
    <!--
      <div class="h-2 bg-gray-600 text-xs leading-none text-center font-thin text-gray-500"
           :style="{width:timePercentageCompleted}"
           >&nbsp;</div>
    -->



    <div v-if='windowDuration < timeline.duration && !isCondensed' class="flex-none w-full shadow bg-gray-900 self-center relative" :class='topHeightClass' >

      <div class="absolute top-0 left-0 right-0 bottom-0 bg-gray-800"
           :style="{width:timePercentageCompleted}"
           >&nbsp;</div>

      <timeline-event v-for='event in timeline.timeline'
                      :event='event'
                      :timeline='timeline'
                      :timeline-element-width='timelineElementWidth'
                      :window-duration='timeline.duration'
                      :disable-sides='true'
                      :height-class='topHeightClass'
                      :window-center='timeline.duration/2'
                      :color='transformsToColorMap[event.tid]'
                      :is-active='selectedTransformTid === event.tid'
                      :show-label='false'
                      class='opacity-25'
                      :current-time='currentTime'
                      @updated='onUpdated'
                      :key='event.id' />

      <timeline-cursor v-if='windowDuration < timeline.duration && !isCondensed' v-model='windowCenter'
                       @input='onUpdateScrollFromWindow'
                       :duration='timeline.duration'
                       :height-class='topHeightClass'
                       :timeline-element-width='timelineElementWidth'
                       class='pbc-z-level-1'
                       :window-duration='windowDuration' />

    </div>

      <!--
    <div ref='lol'
          class="mt-2 bg-gray-600 text-xs leading-none text-center font-thin text-gray-500 h-2"
          :style="{width:windowTimePercentageCompleted}"
          >&nbsp;</div>
      -->
      <div class="m-0 p-0 w-full overflow-y-auto" >
        <div ref='timelineColumn' class="overflow-y-auto overflow-x-auto flex flex-row p-0 m-0" @scroll='onScrollTimelineColumn'>
          <div class="timeline-option flex-none flex flex-col">
            <template v-for='[tid,color] in transformsToColorList'>
              <template v-for='([id,tl],i) in filteredAndGroupedTransforms[tid]'>
                <slot name='tid'
                      :tid='tid'
                      :color='color'
                      :select='select'
                      :selected='selectedTransformTid === tid'
                      :i='i'
                      />
                <slot v-if='selectedTransformTid !== tid'
                      name='selectedtid'
                      :tid='tid'
                      :color='color'
                      :select='select'
                      :selected='selectedTransformTid === tid'
                      :i='i'
                      />
              </template>
            </template>
          </div>
          <div class="timeline-column w-full">
            <template v-for='[tid] in transformsToColorList'>
              <template v-for='([id,tl]) in filteredAndGroupedTransforms[tid]'>

                  <div v-if='selectedEntry.tid === tid' :style='{width:timelinesWidth + "px"}' :key='id + "-" + tid'>
                    <div class="w-full shadow bg-gray-900 self-center flex-none relative"
                        :class='heightClass'
                        @dblclick="onTimelineRowDblClick($event, tid)"
                        @touchstart.passive="onTimelineRowTouchStart($event, tid)"
                        @touchend.passive="onTimelineRowTouchEnd"
                        @touchmove.passive="onTimelineRowTouchMove"
                      >
                      <div class="absolute top-0 left-0 right-0 bottom-0 bg-gray-700 pointer-events-none"
                          :style="{width:timePercentageCompleted}"
                          >&nbsp;</div>

                      <div v-if='tl.filter(e => e.__type === "animation").length === 0'
                           class="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <span class="text-gray-500 text-xs select-none">Double-click or long-press to add a block</span>
                      </div>

                        <timeline-event v-for='event in tl'
                                        :event='event'
                                        :timeline='timeline'
                                        :timeline-element-width='timelinesWidth'
                                        :window-duration='timeline.duration'
                                        :height-class='heightClass'
                                        :window-center='timeline.duration / 2'
                                        :color='transformsToColorMap[event.tid]'
                                        :is-active='true'
                                        :is-selected='selectedEntry.cid == event.cid'
                                        :current-time='currentTime'
                                        :show-label='true'
                                        @select='onSelectEntry'
                                        @updated='onUpdated'
                                        @add-timeline-event='onAddTimelineEvent'
                                        @remove='$emit("remove-timeline-event", $event)'
                                        :key='id + event.id' />

                      </div>
                  </div>

              </template>
            </template>
          </div>
        </div>
              
            <!--
            <tr v-if='hasSelectedCid' :key='"selected-" + tid + "-" + i' class="flex flex-row">
              <td colspan="2" class="overflow-x-auto">
                <slot v-if='hasSelectedCid'
                      name='aftertimeline'
                      :tid='tid'
                      :color='color'
                      :selected-entry='selectedEntry'
                      :selected='true'
                      />
              </td>

            </tr>
    <div v-if='!isCondensed' class="flex flex-row">
        <slot v-if='selectedEntry.tid'
              name='selected-entry'
              :selected-entry='selectedEntry'
              :cid='selectedEntry.cid'
              :tid='selectedEntry.tid' />
            -->
    </div>

      <slot name='aftertimeline'
            :tid='selectedEntry.tid'
            :color='transformsToColorMap[selectedEntry.tid]'
            :selected-entry='selectedEntry'
            :selected='true'
            />
    <pbc-popup v-if='chooseTimelimit' @close='chooseTimelimit = false'>
      <div class="p-2 flex flex-col">
        <h1 class="text-lg">Choose duration:</h1>
        <pbc-button @click='setTimelimit(3)'>3 seconds</pbc-button>
        <pbc-button @click='setTimelimit(5)'>5 seconds</pbc-button>
        <pbc-button @click='setTimelimit(8)'>8 seconds</pbc-button>
        <pbc-button @click='setTimelimit(10)'>10 seconds</pbc-button>
        <pbc-button @click='setTimelimit(12)'>12 seconds</pbc-button>
        <pbc-button @click='setTimelimit(15)'>15 seconds</pbc-button>
        <div class="flex flex-row">
          <span>Custom</span>
          <numberer v-model='customTimelimit' />
        </div>
      </div>
    </pbc-popup>


  </div>
</template>
<script>
import TimelineClockOutline from '@icons/TimelineClockOutline.vue';
import ClockTimeTwelveOutline from '@icons/ClockTimeTwelveOutline.vue';
import ClockTimeThreeOutline from '@icons/ClockTimeThreeOutline.vue';
import ClockTimeSixOutline from '@icons/ClockTimeSixOutline.vue';
import ClockTimeNineOutline from '@icons/ClockTimeNineOutline.vue';

import PbcPopup from '@ui/molecules/PbcPopup.vue';
import { debounce, throttle, uniq, uniqBy, sortBy, toPairs, groupBy } from 'lodash';
import TimelineCursor from '@ui/molecules/TimelineCursor.vue';
import TimelineEvent from '@ui/molecules/TimelineEvent.vue';
export default {
  props:{
    timeline:{
      type: Object,
      required: true
    },
    windowDuration: {
      type: Number,
      required: true
    },
    currentTime: {
      type: Number,
      required: true
    },
    initialSelectedTransformTid: {
      type: String,
      default: ''
    },
    isCondensed:{
      type:Boolean,
      default:false
    }
  },
  components: {
    TimelineEvent,
    TimelineCursor,
    PbcPopup,
    //TimelineClockOutline
  },
  data() {
    const colors = [
      '#9E0095',
      '#009124',
      '#FF4958',
      '#904713',
      '#001089',
      '#FF681F',
      '#FCD667',
      '#B5B35C',
      '93DFB8',
      '#6CDAE7',
      '#C9A0DC'

    ];

    let selectedTransformTid = this.initialSelectedTransformTid;
    let selectedEntry = this.timeline.timeline[0] || {};
    if (!!this.initialSelectedTransformTid) {
      selectedEntry = this.timeline.timeline.filter( ({tid}) => {
        return tid === this.initialSelectedTransformTid;
      })[0];
    } else {
      if (this.timeline.timeline.length) {
        selectedTransformTid =this.timeline.timeline[0].tid;
      }
    }

    const filteredAndGroupedTransforms = {};
    const onScrollTimelineColumn = throttle(this._onScrollTimelineColumn, 50);
    return {
      timelineElementWidth: 0,
      windowCenter:0,
      colors,
      transformsToColorMap:{},
      transformsToColorList:[],
      selectedTransformTid,
      selectedEntry:selectedEntry,
      chooseTimelimit:false,
      filteredAndGroupedTransforms,
      timelinesWidth:400,
      onScrollTimelineColumn,
      longPressTimer: null,
      longPressTid: null,
      longPressX: 0,
    }
  },
  mounted() {
    const bb = this.$el.getBoundingClientRect();
    this.timelineElementWidth = bb.width;
    this.windowCenter = this.windowDuration / 2;
    if (this.selectedTransformTid) {
    }
    this.$emit('select-transform-id', this.selectedTransformTid, this.transformsToColorMap[this.selectedTransformTid]);
    this.filteredAndGroupedTransforms = this.filterTimelineByTransform(this.timeline.timeline);
    this.timelinesWidth = this.timeline.duration / this.windowDuration * this.timelineElementWidth;
  },
  methods: {
    _onScrollTimelineColumn({target}) {
      const scrollLeft = target.scrollLeft;

      this.setWindowCenterFromScroll(scrollLeft);
    },
    setScrollOffsets(scrollLeft) {
      const el = this.$refs.timelineColumn;
      el.scrollLeft = scrollLeft;
    },
    setWindowCenterFromScroll(pixelsWindowStart) {
      const windowStart = pixelsWindowStart / this.timelinesWidth * this.timeline.duration;
      this.windowCenter = windowStart + this.windowDuration/2;
    },
    onUpdateScrollFromWindow(nv) {
      const windowStart = nv - this.windowDuration/2;
      const pixels = windowStart / this.timeline.duration * this.timelinesWidth;
      this.setScrollOffsets(pixels);
    },
    filterTimelineByTransform(timeline) {
      const filteredAndGrouped = {};
      const tids = uniq(timeline.map( ({tid}) => { return tid } ));

      tids.forEach( (in_tid) => {
        let thisTid;
        if (in_tid !== this.selectedTransformTid) {
          const thisTimeline = timeline.filter( ({tid}) => {
            return tid === in_tid;
          })
          const hasSelectedCid = thisTimeline.filter( ({cid}) => {
            return cid === this.selectedEntry.cid;
          }).length > 0;
          thisTid = [
            ['main',
              thisTimeline,
              hasSelectedCid
            ],
          ];
        } else {
          const t = timeline.filter( ({tid}) => {
            return tid === in_tid;
          });
          const bla = toPairs(
            groupBy(t, ({cid,label,__type}) => {
              if (['enter', 'exit'].includes(__type.toLowerCase())) {
                return 'main';
              }
              return 'others';
            })
          ).map( ([cid,timeline]) => {
            const hasSelectedCid = timeline.filter( ({cid}) => {
              return cid === this.selectedEntry.cid;
            }).length > 0;
            return [cid,timeline, hasSelectedCid];
          });
          thisTid = bla;
        }
        filteredAndGrouped[in_tid] = thisTid;
          
      });
      return filteredAndGrouped;


    },
    onAddTimelineEvent(fromEvent) {
      this.$emit('add-timeline-event', fromEvent);
      console.log('change timeline filter data');
      this.filteredAndGroupedTransforms = this.filterTimelineByTransform(this.timeline.timeline);
    },
    onUpdated({event}) {
      console.log('le updated', event);
      this.$emit('updated-entry', {event});
    },
    onSelectTransformTid(tid) {
      console.log('select transform tid', tid);
      this.selectedTransformTid = tid;
      const color = this.transformsToColorMap[this.selectedTransformTid];
      console.log('macolor', color);
      this.$emit('select-transform-id', this.selectedTransformTid, color);
      console.log('change timeline filter data');
      this.filteredAndGroupedTransforms = this.filterTimelineByTransform(this.timeline.timeline);
    },
    setTimelimit(seconds, closeTimelimitChanger=true) {
      this.$emit("set-timelimit", {seconds});
      this.windowCenter = this.windowDuration / 2;
      if (closeTimelimitChanger) {
        this.chooseTimelimit = false;
      }
    },
    select(tid) {
      this.selectedTransformTid = tid;
      this.selectedEntry = this.timeline.timeline.filter( ({tid}) => {
        return tid === this.selectedTransformTid
      })[0];
      const color = this.transformsToColorMap[tid];
      console.log('macolor', color);
      this.$emit('select-transform-id', tid, color);
      console.log('change timeline filter data');
      this.filteredAndGroupedTransforms = this.filterTimelineByTransform(this.timeline.timeline);
    },
    onSelectEntry(entry, autoselect) {
      console.log('am selecting', entry);
      console.log('hav select', this.selectedEntry);
      this.selectedEntry = entry;
      this.onSelectTransformTid(entry.tid);

      if (false && autoselect) {
        setTimeout( () => {
          console.log('am scroll now', entry.id);
          document.querySelector("#tl-event-" + entry.id).scrollIntoView();
        }, 1000);
      }
    },
    _timeFromRowEvent(e, clientX) {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = clientX - rect.left;
      return Math.max(0, Math.min(x / this.timelinesWidth * this.timeline.duration, this.timeline.duration));
    },
    onTimelineRowDblClick(e, tid) {
      // Don't trigger when double-clicking an existing event block
      if (e.target.closest('[id^="tl-event-"]')) return;
      const time = this._timeFromRowEvent(e, e.clientX);
      const copyFromCid = this.selectedEntry && this.selectedEntry.cid;
      this.onAddTimelineEvent({ event: { tid, start: time, duration: 0, copyFromCid } });
    },
    onTimelineRowTouchStart(e, tid) {
      if (e.target.closest('[id^="tl-event-"]')) return;
      const touch = e.touches[0];
      const rect = e.currentTarget.getBoundingClientRect();
      this.longPressTid = tid;
      this.longPressX = touch.clientX - rect.left;
      clearTimeout(this.longPressTimer);
      this.longPressTimer = setTimeout(() => {
        this.longPressTimer = null;
        const time = Math.max(0, Math.min(this.longPressX / this.timelinesWidth * this.timeline.duration, this.timeline.duration));
        const copyFromCid = this.selectedEntry && this.selectedEntry.cid;
        this.onAddTimelineEvent({ event: { tid: this.longPressTid, start: time, duration: 0, copyFromCid } });
      }, 500);
    },
    onTimelineRowTouchEnd() {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    },
    onTimelineRowTouchMove() {
      // Cancel long press if the user starts scrolling
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    },
  },
  computed:{
    customTimelimit: {
      get() {
        return this.timeline.duration;
      },
      set(nv) {
        const t = parseFloat(nv);
        if (!isNaN(t)) {
          this.setTimelimit(parseFloat(nv), false);
        }
      }
    },
    heightClass() {
      return !this.isCondensed ? 'h-12' : 'h-4';
    },
    topHeightClass() {
      return !this.isCondensed ? 'h-12' : 'h-4';
    },
    timePercentageCompleted() {
      return ((this.currentTime / this.timeline.duration) * 100).toFixed(2) + '%';
    },
    windowTimePercentageCompleted() {
      const windowStart = this.windowCenter - this.windowDuration/2;
      const pc = (( (this.currentTime - windowStart) / this.windowDuration) * 100).toFixed(2) ;
      return Math.max(0, Math.min(100, pc)) + '%';
    }

  },
  watch:{
    'timeline.duration'() {
      this.timelinesWidth = this.timeline.duration / this.windowDuration * this.timelineElementWidth;
    },
    'selectedEntry.start'() {
    },
    'selectedEntry.end'() {
    },
    'timeline.timeline.length'() {
      console.log('change timeline filter data');
      this.filteredAndGroupedTransforms = this.filterTimelineByTransform(this.timeline.timeline);
    },
    timeline: {
      handler(nv) {
        const transformsToColorMap = {};
        let lastColor = 0;
        let tids = uniqBy(this.timeline.timeline.map( ({tid}) => {
          return tid;
        }));

        tids = sortBy(tids);

        tids.forEach( (tid) => {
          if (!transformsToColorMap[tid]) {
            transformsToColorMap[tid] = this.colors[lastColor % this.colors.length];

            lastColor++;
          }
        });
        this.transformsToColorMap = transformsToColorMap;
        this.transformsToColorList = toPairs(transformsToColorMap);

        // check if selected entry no longer exists
        if (this.selectedEntry && this.selectedEntry.id) {
          const selectedEntryStillExists = this.timeline.timeline.filter( ({id}) => {
            return id === this.selectedEntry.id;
          }).length > 0;
          if (!selectedEntryStillExists) {
            this.selectedEntry = this.timeline.timeline.filter( ({tid}) => {
              return tid === this.selectedTransformTid;
            })[0];

          }
        }
      },
      immediate: true
    }
  }
}
</script>
<style>
</style>
